import type { REDecisionEntry } from "@/hooks/useREDecisionLog";
import { getRealm } from "@/components/lunimar/lunimarRealms";
import { ConsequencePanel, LumiSignalCard } from "@/components/lunimar-kit";

/**
 * Inline consequence banner — surfaces the most recent committed decision
 * inside the RE Investing simulator. Built on the Lunimar kit so it
 * matches every other realm.
 */
export default function DecisionConsequenceStrip({
  entry,
}: {
  entry: REDecisionEntry | null;
}) {
  if (!entry) return null;
  const realm = getRealm("re_investing");
  const positive = entry.scoreDelta >= 0;
  const tone = positive
    ? entry.scoreDelta >= 2
      ? "good"
      : "active"
    : entry.scoreDelta <= -2
      ? "danger"
      : "caution";

  return (
    <div className="mb-4 space-y-2">
      <ConsequencePanel
        realm={realm}
        tone={tone}
        title={entry.label}
        summary={entry.consequence}
        walletDelta={entry.walletImpact}
        walletPersisted={false}
        shift={entry.round != null ? `Quarter Q${entry.round}` : undefined}
      />
      {entry.lumiSignal && (
        <LumiSignalCard realm={realm} tag={positive ? "Insight" : "Watch"}>
          {entry.lumiSignal}
        </LumiSignalCard>
      )}
    </div>
  );
}